import RootStore from "@state/stores/RootStore";
import { getCurrentCulture } from "@utils";
import { action, observable } from "mobx";

export default class CountryChangeStore {
	@observable isCountryChangePopupActive: boolean | false = false;
	@observable errorMessage: string | null = null;

	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	@action.bound
	activatePopup(errorMessage: string) {
		this.isCountryChangePopupActive = true;
		this.errorMessage = errorMessage;
	}

	@action.bound
	async deactivatePopupAndLogoutUser() {
		await this.rootStore.userAuthStore.logoutUser();

		this.isCountryChangePopupActive = false;
		this.errorMessage = null;

		App.state.redirect(`/${getCurrentCulture()}/home`);
	}
}
